import {createAction} from 'redux-act';

export const SEND_REQUEST = createAction('flyers/SEND_REQUEST');
export const SET_LOADING = createAction('flyers/SET_LOADING');
export const TOGGLE_REQUEST_MODAL = createAction('flyers/TOGGLE_REQUEST_MODAL');
